import React from 'react';
import { motion } from 'framer-motion';
import { ContactSection } from '../components/ContactSection';
export function ContactPage() {
  return <div className="bg-[#FAF9F7] min-h-screen" data-id="element-312">
      <div className="bg-[#4A0000] py-16 text-center" data-id="element-313">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-4xl md:text-5xl font-bold text-white font-serif" data-id="element-314">
          Contact Us
        </motion.h1>
      </div>
      <ContactSection data-id="element-315" />
    </div>;
}